import React from 'react'
import ProgressBar from './Mui/CustomProgressBar'
import ImagePreview from './Mui/ImagePreview'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import { Control } from 'react-redux-form'
import Typography from '@material-ui/core/Typography';


class ImageSubForm extends React.Component {
  render() {
    const {
      progress,
      image, imageReady, imageValid, imageFile,
      handleDeleteImage, handleUploadImage
    } = this.props

    return (
      <div className="pl-24 pr-24 pb-24">

          {
            progress > 0 && !imageReady && (
              <ProgressBar />
            )
          }
          {
            progress === 0 && image === null && (
             <React.Fragment>
               <Typography className="h6 mb-8">Image File</Typography> 
               <Typography className="caption mb-16">(file must be in JPG, PNG or SVG format, max file size 600KB)</Typography>  
               <CustomOutlinedButton
                 className="buttonnoto c-blue align-self-center mr-16"
                 onClick={e=>{
                   document.getElementById('question-image').click()
               }}>UPLOAD IMAGE</CustomOutlinedButton>
               <span
                className={`TextInput-error ${imageValid ? 'd-none' : ''}`}
                style={{fontSize: 12}}>
                 Image file is required
               </span>
             </React.Fragment>
           )
          }
          {
            image !== null && imageReady &&
            (
              <ImagePreview
                source={image}
                filename={imageFile}
                showDelete={true}
                handleDelete={handleDeleteImage}
              />
            )
          }

          <Control.file
            id="question-image"
            model="sea"
            changeAction={handleUploadImage}
            accept=".png,.jpg,.svg"
            className="d-none"
          />
      </div>
    )
  }
}

export default ImageSubForm



// WEBPACK FOOTER //
// ./src/js/components/ImageSubForm.js